<template>
</template>

<script>
import {jumpWxAuth,getToken,getQueryString,configApi} from '@/utils/common'
import config from '@/utils/config'
import router from '@/router/index'	
export default {
  name: 'login',
  data() {
		return {
			vid:null,
		}
  },
  mounted() {

  },
  methods: {

  }  
}
	
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/login/login.vue